import React from 'react';
import LayoutSSR from '../layout/LayoutSSR';
import HomeSSR from '../pages/Home/layout';
import { FOOTER_DATA } from '../pages/Home/constants';
const HomeSSRComponent = ({ isLoggedSSR, deviceType, showExtoleReferFriend, registrationFlow }) => {
    return (React.createElement(LayoutSSR, { isSticky: true, isLoggedSSR: isLoggedSSR, registrationFlow: registrationFlow, footerData: FOOTER_DATA, showExtoleReferFriend: showExtoleReferFriend },
        React.createElement(HomeSSR, { deviceType: deviceType })));
};
export default HomeSSRComponent;
